<template>
  <div class="layout">
    <nav class="top-navigation-menu">
      <app-navbar />
    </nav>
    <main class="flex">
      <app-sidebar />
      <div class="main-content" :class="{ 'nav-collapsed': isSideNavCollapsed }">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import AppSidebar from "./sidebar/TheSidebar";
import AppNavbar from "./navbar/TheNavbar";
export default {
  components: {
    AppSidebar,
    AppNavbar,
  },
  computed: {
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
  },
};
</script>

<style>
.main-content {
  height: calc(100vh - 4rem);
  background: var(--lightblue);
  flex: 1;
  overflow-y: auto;
  margin-top: 4rem;
  transition: all ease 0.3s;
  padding: 1.5rem;
}
.nav-collapsed {
    margin-left: 1px !important;
  }
/* .top-navigation-menu {
  max-width: 80vw;
  margin-left: 20vw;
} */

@media screen and (max-width: 1024px) {
  .main-content {
    margin-left: 0;
    padding: 1rem 0.5rem;
  }
  .nav-collapsed {
    margin-left: 1px !important;
  }
}
</style>
